import {
  useMemo
} from 'react';
import {
  useGetCoinPackagesQuery,
  WELCOME_OFFER_BONUS_PLAN_IDS
} from '@entities/coins';

export const useGetWelcomePackages = () => {
  const { isFetching, data } = useGetCoinPackagesQuery(undefined, {
    refetchOnMountOrArgChange: true
  });

  const coinPackages = useMemo(() => {
    const packages = data ?? [];
    // TODO: Refactor this logic to be more generic and reusable - move to backend
    const filtered = packages.filter(coinPackage => {
      const isNotHidden = !coinPackage.hidden;
      const isLimited = coinPackage.isLimited;
      const isWelcomeOffer = WELCOME_OFFER_BONUS_PLAN_IDS.includes(coinPackage.bonusPlanId);
      return isNotHidden && isLimited && isWelcomeOffer;
    });
    const sorted = filtered.sort(({ order: firstOrder }, { order: secondOrder }) => firstOrder - secondOrder);
    return sorted;
  }, [data]);

  return { isFetching, coinPackages };
};
